
<template>
  <footer class="footer">
    <p>Address: 7053 Montecito Ln, Eastvale, CA 92880</p>
    <p>Email: contact@ifusion.cc</p>
    <p>Website: <a href="https://www.ifusion.cc" target="_blank">https://www.ifusion.cc</a></p>
  </footer>
</template>

<!--template>
  <footer>
    <p>Address: 7053 Montecito Ln, Eastvale, CA 92880</p>
    <p>Email: cnfusion@163.com</p>
    <p>Website: <a href="https://www.ifusion.cc" target="_blank">https://www.ifusion.cc</a></p>
  </footer>
</template>

<style>

footer {
  background: #35495e;
  color: white;
  text-align: center;
  padding: 1rem 0;
  position: fixed;
  bottom: 0;
  width: 100%;
}

footer p {
  margin: 0;
}
</style-->